import axios from "axios";
import React, { useEffect } from "react";
import { initMixpanel, trackEvent, parseUTMParameters, generateTrackingId, addTrackingIdToUrl } from "./utils/mixpanel";

// // Axios request logging
// axios.interceptors.request.use((config) => {
//   console.log("[axios request]", config.method?.toUpperCase(), config.url, config.data ?? "");
//   return config;
// });

// // Axios response/error logging
// axios.interceptors.response.use(
//   (response) => {
//     console.log("[axios response]", response.status, response.config.url, response.data);
//     return response;
//   },
//   (error) => {
//     console.log("[axios error]", error.message, error.response?.status, error.response?.data);
//     return Promise.reject(error);
//   }
// );

const APP_DETAILS = {
  IOS_APP_STORE_ID: "1660956060",
  ANDROID_PACKAGE_NAME: "com.sfs_mobile_app",
  DEEP_LINK_URL: "https://app.surgeonsforsurgeons.com",
  WEB_APP_URL: process.env.REACT_APP_WEB_URL,
};

// Helper: extract iOS version from User-Agent
const getIOSVersion = (userAgent) => {
  const match = userAgent.match(/OS (\d+)[._](\d+)/i);
  if (match) return `${match[1]}.${match[2]}`;
  const versionMatch = userAgent.match(/Version\/(\d+)[._](\d+)/i);
  if (versionMatch) return `${versionMatch[1]}.${versionMatch[2]}`;
  return null;
};

// Helper: locale (e.g. en-US, fr-FR)
const getLocale = () => {
  return navigator.language || navigator.userLanguage || "unknown";
};

// Helper: platform — ios | android | web
const getPlatform = (userAgent) => {
  const ua = userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return "ios";
  if (/android/.test(ua)) return "android";
  return "web";
};

export default function App() {
  useEffect(() => {
    // Initialize Mixpanel
    // initMixpanel();

    let redirectTimeout;

    const handleRedirect = async () => {
      const ua = navigator.userAgent;
      const userAgent = ua.toLowerCase();
      const isMobile = /iphone|ipad|ipod|android|mobile/.test(userAgent);
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      console.log(isIOS, "isIOS1");
      const platform = getPlatform(ua);

      const currentUrl = new URL(window.location.href);
      const utm_parameters = currentUrl.search ? currentUrl.search.slice(1) : "";

      // Generate unique tracking ID for conversion tracking
      // const trackingId = generateTrackingId();

      const screenResolution = `${window.screen.width}x${window.screen.height}`;
      const devicePixelRatio = window.devicePixelRatio;

      let ip = "";
      try {
        const ipRes = await fetch("https://api.ipify.org?format=json");
        const data = await ipRes.json();
        ip = data.ip ?? "";
      } catch (e) {
        console.warn("[deeplink] Could not fetch IP", e);
      }

      // Store API payload — same for all platforms (ios, android, web)
      const userData = {
        screenResolution,
        devicePixelRatio,
        platform,
        linkPressed: `sfs:/${window.location.pathname}`,
        userAgent: ua,
        ipAddress: ip,
        os_version: getIOSVersion(ua),
        device_id: null,
        locale: getLocale(),
        utm_parameters,
        // tracking_id: trackingId,
      };

      // Parse UTM parameters for Mixpanel
      const utmParams = parseUTMParameters(currentUrl.search);

      // // Track deeplink opened event with URL, UTM parameters, userData, and tracking ID
      // trackEvent("Deeplink Opened", {
      //   url: window.location.href,
      //   raw_url: window.location.href,
      //   domain: currentUrl.hostname,
      //   pathname: currentUrl.pathname,
      //   search: currentUrl.search,
      //   tracking_id: trackingId, // Unique tracking ID for conversion tracking
      //   ...userData, // Include all userData properties
      //   ...utmParams, // Spread UTM parameters as individual properties
      // });
      let refer_id = null

      // Store API — called for all platforms (ios, android, web) before any redirect
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
      if (apiBaseUrl && apiBaseUrl !== "undefined") {
        const storeApiUrl = `${apiBaseUrl}/api/v1/deeplink/store`;
        console.log("[deeplink] Calling store API", storeApiUrl, userData);
        try {
          const res = await axios.post(storeApiUrl, userData);
          refer_id = res?.data?.data?.id
          console.log(refer_id, "refer_id");
          console.log("[deeplink] Store API success");
        } catch (error) {
          console.log("[deeplink] Store API error", error.message, error.response?.status, error.response?.data);
        }
      } else {
        console.warn("[deeplink] REACT_APP_API_BASE_URL not set, skipping store API. Set it in .env for web and other platforms.");
      }

      // Web (desktop): redirect to web app only after store API has been called
      if (platform === "web") {
        const webAppUrl = process.env.REACT_APP_WEB_URL;
        if (webAppUrl && webAppUrl !== "undefined") {
          const redirectPath = `${currentUrl.pathname}${currentUrl.search}`;
          let target = redirectPath ? `${webAppUrl.replace(/\/$/, "")}${redirectPath}` : webAppUrl;
          // Add tracking ID to redirect URL
          //target = addTrackingIdToUrl(target, trackingId);
          // Ensure store API request has completed before navigation (avoids abort on unload)
          window.location.replace(target);
          return;
        }
        // If no web app URL, fall through to openApp() (store redirect after 2.5s)
      }
      const referrerPayload = new URLSearchParams({
        path: currentUrl.pathname,
        ref_code: String(refer_id),
        ...Object.fromEntries(currentUrl.searchParams), // utm_source, utm_campaign, tracking_id, etc.
      }).toString();


      const providerToken = "125905200";
      const utmSource = currentUrl.searchParams.get("utm_source") || "organic";
      currentUrl.searchParams.set("ref_code", String(refer_id));
      // Store URLs for mobile
      let storeUrl = null
      if (isIOS) {
        storeUrl = `https://apps.apple.com/app/id${APP_DETAILS.IOS_APP_STORE_ID}`

      }
      else {
        const playStoreUrl = new URL(
          "https://play.google.com/store/apps/details"
        );

        playStoreUrl.searchParams.set(
          "id",
          APP_DETAILS.ANDROID_PACKAGE_NAME
        );

        // Add UTM parameters for Play Console reporting
        Object.entries(utmParams).forEach(([key, value]) => {
          playStoreUrl.searchParams.set(key, value);
        });

        // Add Install Referrer for deferred deep linking
        playStoreUrl.searchParams.set(
          "referrer",
          referrerPayload
        );

        storeUrl = playStoreUrl.toString();
      }
      // const openApp = () => {
      //   if (isIOS) {
      //     redirectTimeout = setTimeout(() => {
      //       window.location.replace(storeUrl);
      //     }, 10000);
      //   } else {
      //     // Add tracking ID to deep link URL for Android
      //     //const deepLinkUrl = addTrackingIdToUrl(APP_DETAILS.DEEP_LINK_URL, trackingId);
      //     const deepLinkUrl = APP_DETAILS.DEEP_LINK_URL;
      //     const iframe = document.createElement("iframe");
      //     iframe.style.display = "none";
      //     iframe.src = deepLinkUrl;
      //     document.body.appendChild(iframe);
      //     redirectTimeout = setTimeout(() => {
      //       window.location.replace(storeUrl);
      //     }, 2500);
      //   }
      // };
      console.log(isIOS, "isIOS2");

      const openApp = () => {
        if (isIOS) {
          console.log(isIOS, "isIOS3");

          redirectTimeout = setTimeout(() => window.location.replace(storeUrl), 3500);
        } else {
          const intentUrl =
            `intent://${currentUrl.host}${currentUrl.pathname}${currentUrl.search}#Intent;` +
            `scheme=https;package=${APP_DETAILS.ANDROID_PACKAGE_NAME};` +
            `S.browser_fallback_url=${encodeURIComponent(storeUrl)};end`;

          console.log("[deeplink] Firing intent:", intentUrl);
          window.location.href = intentUrl;

          redirectTimeout = setTimeout(() => {
            console.log("[deeplink] Timeout hit — no visibilitychange detected, falling back to store");
            window.location.replace(storeUrl);
          }, 2500);
        }
      };
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          console.log("[deeplink] Tab hidden — intent succeeded (app opened), cancelling fallback");
          clearTimeout(redirectTimeout);
        }
      });
      openApp();
    };

    handleRedirect();

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center p-4">
      <div className="text-center">
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 relative">
            <div className="w-16 h-16 rounded-full border-4 border-blue-200 border-t-blue-500 animate-spin"></div>
          </div>
        </div>
        <div className="space-y-3">
          <h1 className="text-2xl font-semibold text-gray-800">Opening App...</h1>
          <p className="text-gray-600">Redirecting to store if app is not installed</p>
        </div>
      </div>
    </div>
  );
}
